<template>
    <div class="home-page content-page">
		<Header></Header>
		<div class="list" v-if="!notFound">
			<div class="nav flex">
				<div class="back" @click="back">
					<img src="static/images/return.png" />
				</div>
			</div>
      <div class="crfff" style="margin: 0 20px;">
        <div class="fs46">{{title}}</div>
        <div class="fs33 mt30">{{name}}</div>
      </div>
			<div class="section-list mt30">
				<div class="section-content">
					<div class="content-list" @click="toContentDetail(item.chapter_id)"  v-for="(item,index) in list">
						<p class="title fs40">{{index+1}}.{{item.title}}</p>
						<div class="content-desc mt30">
							<div class="descent" v-html="item.content"></div>
						</div>
            <!-- <div class="content-href ar">
              <span class="cr5667fd">{{$t('seeMore')}} <img width="26" src="../../static/images/more.png" /></span>
            </div> -->
					</div>
				</div>
			</div>
			<div class="mt50 ac crfff more" @click="getMore" v-if="total>5&&list.length<total">
				{{$t('clickMore')}} >>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../components/HeaderNoLogo'
export default {
    components:{
		Header
    },
    data() {
      return {
        notFound:false,
        list:[],
        page:1,
        isShow:true,
        title:'',
        name:'',
        total:0
      }
    },
    created(){
      this.getHome()
      this.title = this.$route.query.title
      this.name = this.$route.query.name
    },
    methods: {
		back(){
			this.$router.go(-1);
		},
		toContentDetail(id){
      return
			this.$router.push({path:'/contentDetail',query: {id:id}})
		},
		getHome(){
			let that =this;
			that.$parent.loadModal(true);
			let data = {
        chapter_id:this.$route.query.id,
        page:that.page
      }
			that.$api.post('/api/index/content',data,r =>{
				that.$parent.returnCode(r,function(){
          that.total = r.data.total
					that.$parent.loadModal(false);
					if(that.page>1){
					  if(r.data.list.length>0){
					    that.list = that.list.concat(r.data.list)
					  }else{
					    console.log(222)
					    that.isShow = false;
					    that.$utils.alertText(that.$t('noMore'));
					    that.page = 1
					  }
					}else{
					  that.list = r.data.list
					  that.isShow = true;
					}
       });

			})
		},
		getMore(){
			let that = this;
			if(that.isShow){
				that.page++;
				that.getHome();
			}else{
				that.$utils.alertText(that.$t('noMore'));
			}
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/contentList.vue